// Add rel="external" if href points to a non-.gov hostname
export function markExternalLinks(): void {
	const links = document.querySelectorAll<HTMLAnchorElement>("a:not([class])");

	for (const anchor of links) {
		const href = anchor.getAttribute("href");
		if (!href) continue;

		let url: URL;
		try {
			url = new URL(href, globalThis.location.origin);
		} catch {
			continue;
		}

		if (!url.protocol.startsWith("http")) continue;

		// Skip if internal
		if (url.hostname === globalThis.location.hostname) continue;

		const tld = url.hostname.split(".").pop();
		if (tld !== "gov") {
			anchor.setAttribute("rel", "external");
		}
	}
}
